<template src="./BaseButton.html"></template>

<script lang="ts">
import { defineComponent, StyleValue } from "vue";
import AppIcon from "@/components/AppIcon";

export default defineComponent({
    components: { AppIcon },
    props: {
        dark: { type: Boolean, default: false },
        simple: { type: Boolean, default: false },
        block: { type: Boolean, default: false },
        link: { type: String, default: "" },
        submit: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        icon: { type: String, default: "" },
        iconColor: { type: String, default: "" },
        width: { type: Number, required: false },
        success: { type: Boolean, default: false },
        danger: { type: Boolean, default: false }
    },
    emits: ["click"],
    computed: {
        classes(): string[] {
            const classes = ["btn"];

            if (this.dark) classes.push("btn-dark");
            else if (this.simple) classes.push("btn-simple");
            else classes.push("btn-primary");

            if (this.block) classes.push("btn-block");
            if (this.success) classes.push("btn-success");
            if (this.danger) classes.push("btn-danger");
            if (this.disabled) classes.push("disabled");

            return classes;
        },
        styles(): StyleValue | null {
            if (this.width) {
                return { width: `${this.width}px` };
            }
            return null;
        }
    }
});
</script>

<style src="./BaseButton.scss" lang="scss" scoped></style>
